import React, { useState } from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import ThemeLogo from './ThemeLogo';
import Profile from './Profile';
import Subscriptions from './Subscriptions';
import ChangePassword from './ChangePassword';

export default function Account() {
  const [activeTab, setActiveTab] = useState('profile');
  const navigate = useNavigate();

  return (
    <div style={{ background: '#fff', minHeight: '100vh', padding: 0 }}>
      <Container fluid style={{ maxWidth: 1100, margin: '0 auto', padding: '40px 0 0 0' }}>
        <Row className="align-items-center mb-4">
          <Col xs="auto">
            <ThemeLogo style={{ width: 100, height: 100, marginRight: 12 }} alt="Logo" />
            <span style={{ fontWeight: 700, fontSize: 28, verticalAlign: 'middle', color: '#222', letterSpacing: 1 }}>EPCSPARK</span>
          </Col>
          <Col className="text-end">
            <Button onClick={() => navigate('/')} style={{ background: '#ff4d4f', border: 'none', borderRadius: 12, fontWeight: 600, fontSize: 18, padding: '8px 32px', boxShadow: '0 4px 16px rgba(255,77,79,0.13)' }}>Logout</Button>
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <div className="profile-tabs mb-4 mt-2">
              <button
                className={`profile-tab-btn${activeTab === 'profile' ? ' active' : ''}`}
                onClick={() => setActiveTab('profile')}
                type="button"
              >
                Profile
              </button>
              <button
                className={`profile-tab-btn${activeTab === 'subscriptions' ? ' active' : ''}`}
                onClick={() => setActiveTab('subscriptions')}
                type="button"
              >
                Subscriptions
              </button>
              <button
                className={`profile-tab-btn${activeTab === 'change-password' ? ' active' : ''}`}
                onClick={() => setActiveTab('change-password')}
                type="button"
              >
                Change Password
              </button>
            </div>
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            {activeTab === 'profile' && <Profile />}
            {activeTab === 'subscriptions' && <Subscriptions />}
            {activeTab === 'change-password' && <ChangePassword />}
          </Col>
        </Row>
      </Container>
    </div>
  );
}

// Add the following CSS to your main CSS file for the tabs:
/*
.profile-tabs {
  display: flex;
  gap: 32px;
  border-bottom: 1px solid #eee;
  margin-bottom: 2rem;
  margin-top: 0.5rem;
}
.profile-tab-btn {
  background: none;
  border: none;
  outline: none;
  font-weight: 700;
  font-size: 1.13rem;
  color: #000;
  padding: 0 0 10px 0;
  margin: 0;
  position: relative;
  transition: color 0.2s;
  cursor: pointer;
}
.profile-tab-btn.active,
.profile-tab-btn:focus {
  color: #000;
}
.profile-tab-btn.active::after {
  content: '';
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 2.5px;
  background: #2d7cff;
  border-radius: 2px;
  transition: width 0.3s;
}
.profile-tab-btn:not(.active):hover::after {
  content: '';
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 2.5px;
  background: #2d7cff;
  border-radius: 2px;
  transition: width 0.3s;
}
*/ 